import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public isSpinnerVisible = false;

  constructor() {
  }

  public showSpinner() {
    console.log('showSpinner');
    this.isSpinnerVisible = true;
  }

  public hideSpinner() {
    console.log('hideSpinner');
    this.isSpinnerVisible = false;
  }
}
